import {  Text,  Card, Divider, useMantineTheme, Title,Flex,Stack } from '@mantine/core';
import TransportBadge from './component/TransportBadge';
import { IconWheelchair } from '@tabler/icons-react';
import AllergyBadge from './component/AllergyBadge';


export function MemberFamily(props) {
    const theme = useMantineTheme();
    let data = { genre: "", dateOfBirth: Date.now() }
    data = { ...props.props }
    return (
        <Card
            radius="md"
            withBorder
            p="lg"
            sx={(theme) => ({
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
            })}
        >
            <Card.Section bg={theme.colors.blue} p={"xs"} >
                <Title color='white' align="center" order={3}  >
                    Informations
                </Title>
            </Card.Section>
            <Card.Section m={"xs"}>
            <Text>Conjoint : {data.spouse ? data.spouse : null}</Text>

            <Divider my={"md"} />
            <Text w={"100%"} ta={"center"} mb={"md"}>Enfants</Text>
                <Stack>
                    {
                    data.children ? data.children.map((c,i)=> <Text>{`${c.firstName} ${c.lastName} `}</Text>) : null
                    }
                </Stack>
            </Card.Section>
        </Card>
    );
}